import { render, staticRenderFns } from "./PecaPublicitariaUserForm.vue?vue&type=template&id=51d345aa"
import script from "./PecaPublicitariaUserForm.vue?vue&type=script&lang=js"
export * from "./PecaPublicitariaUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports